import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Module-level cache so multiple components don't refetch
let _cmsCache = null;
let _cmsPromise = null;
const _cmsListeners = new Set();

const fetchCms = async () => {
  if (_cmsCache) return _cmsCache;
  if (_cmsPromise) return _cmsPromise;
  _cmsPromise = api
    .get("/cms")
    .then((res) => {
      _cmsCache = res.data || {};
      _cmsListeners.forEach((cb) => cb(_cmsCache));
      return _cmsCache;
    })
    .catch(() => {
      _cmsCache = {};
      return _cmsCache;
    })
    .finally(() => {
      _cmsPromise = null;
    });
  return _cmsPromise;
};

export const useCms = () => {
  const [cms, setCms] = useState(_cmsCache);
  useEffect(() => {
    let alive = true;
    const onChange = (data) => {
      if (alive) setCms(data);
    };
    _cmsListeners.add(onChange);
    if (!_cmsCache) fetchCms().then((d) => alive && setCms(d));
    return () => {
      alive = false;
      _cmsListeners.delete(onChange);
    };
  }, []);
  return cms || {};
};

export const refreshCms = async () => {
  _cmsCache = null;
  return fetchCms();
};

// Listings hook (no caching — always fresh on mount)
export const useListings = (division) => {
  const [items, setItems] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    api
      .get("/listings", { params: division ? { division } : {} })
      .then((res) => {
        if (alive) setItems(res.data || []);
      })
      .catch(() => {
        if (alive) setItems([]);
      })
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [division]);

  return { items, loading };
};
